"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var format_bundle_variant_title_1 = __importDefault(require("../../../utils/format-bundle-variant-title"));
exports.default = (function (_a) {
    var _b;
    var _c = _a.availableChoice, product = _c.product, variant = _c.variant;
    var productsData = (_b = window.vitaminBundlerApp) === null || _b === void 0 ? void 0 : _b.productsData;
    var productData = productsData && productsData[product.handle];
    var variantData = productData === null || productData === void 0 ? void 0 : productData.variants[variant.id];
    return (React.createElement("div", null,
        React.createElement("div", { style: { backgroundColor: "#".concat(productData === null || productData === void 0 ? void 0 : productData.product.hex) } },
            React.createElement("img", { src: product.featured_image })),
        React.createElement("div", { className: 'padding-horizontal-4 padding-vertical-6 medium-padding-10 margin-bottom-6' },
            React.createElement("h1", { className: 'h3' }, (0, format_bundle_variant_title_1.default)(product.title)),
            React.createElement("div", { className: 'divider margin-vertical-6', style: { backgroundColor: "#".concat(productData === null || productData === void 0 ? void 0 : productData.product.hex), height: 8, width: 56 } }, "\u00A0"),
            React.createElement("div", { className: 'text-nobel font-lighter', dangerouslySetInnerHTML: { __html: product.description || '' } })),
        React.createElement("div", { className: 'padding-6', style: { backgroundColor: "#".concat(productData === null || productData === void 0 ? void 0 : productData.product.hex) } },
            React.createElement("img", { src: productData === null || productData === void 0 ? void 0 : productData.product.nutritionalLabelImgUrl })),
        React.createElement("div", { className: 'padding-6' },
            React.createElement("h3", { className: 'h3' }, "Ingredients"),
            React.createElement("div", { className: 'text-nobel font-lighter' }, productData === null || productData === void 0 ? void 0 : productData.product.ingredients))));
});
